import { render, staticRenderFns } from "./PageIgnore.vue?vue&type=template&id=3e5853fb&scoped=true&"
import script from "./PageIgnore.vue?vue&type=script&lang=js&"
export * from "./PageIgnore.vue?vue&type=script&lang=js&"
import style0 from "./PageIgnore.vue?vue&type=style&index=0&id=3e5853fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5853fb",
  null
  
)

export default component.exports